__turbopack_context__.v({
  "accordionSlideOverwrite": "eventSlideOut-module-scss-module__tztGla__accordionSlideOverwrite",
  "actionButton": "eventSlideOut-module-scss-module__tztGla__actionButton",
  "actions": "eventSlideOut-module-scss-module__tztGla__actions",
  "backLink": "eventSlideOut-module-scss-module__tztGla__backLink",
  "backLinkArrow": "eventSlideOut-module-scss-module__tztGla__backLinkArrow",
  "badgeSection": "eventSlideOut-module-scss-module__tztGla__badgeSection",
  "badges": "eventSlideOut-module-scss-module__tztGla__badges",
  "badgesContainer": "eventSlideOut-module-scss-module__tztGla__badgesContainer",
  "badgesHeading": "eventSlideOut-module-scss-module__tztGla__badgesHeading",
  "content": "eventSlideOut-module-scss-module__tztGla__content",
  "contentContainer": "eventSlideOut-module-scss-module__tztGla__contentContainer",
  "error": "eventSlideOut-module-scss-module__tztGla__error",
  "eventInfo": "eventSlideOut-module-scss-module__tztGla__eventInfo",
  "fadeIn": "eventSlideOut-module-scss-module__tztGla__fadeIn",
  "fadeOut": "eventSlideOut-module-scss-module__tztGla__fadeOut",
  "header": "eventSlideOut-module-scss-module__tztGla__header",
  "host": "eventSlideOut-module-scss-module__tztGla__host",
  "hostAvatar": "eventSlideOut-module-scss-module__tztGla__hostAvatar",
  "hostCard": "eventSlideOut-module-scss-module__tztGla__hostCard",
  "hostInfo": "eventSlideOut-module-scss-module__tztGla__hostInfo",
  "hostInfoDescription": "eventSlideOut-module-scss-module__tztGla__hostInfoDescription",
  "hostInfoName": "eventSlideOut-module-scss-module__tztGla__hostInfoName",
  "infoSection": "eventSlideOut-module-scss-module__tztGla__infoSection",
  "learnMore": "eventSlideOut-module-scss-module__tztGla__learnMore",
  "link": "eventSlideOut-module-scss-module__tztGla__link",
  "loadingContainer": "eventSlideOut-module-scss-module__tztGla__loadingContainer",
  "mapContainer": "eventSlideOut-module-scss-module__tztGla__mapContainer",
  "partnerLink": "eventSlideOut-module-scss-module__tztGla__partnerLink",
  "progressBar": "eventSlideOut-module-scss-module__tztGla__progressBar",
  "promoImage": "eventSlideOut-module-scss-module__tztGla__promoImage",
  "registerButton": "eventSlideOut-module-scss-module__tztGla__registerButton",
  "scaleIn": "eventSlideOut-module-scss-module__tztGla__scaleIn",
  "scaleOut": "eventSlideOut-module-scss-module__tztGla__scaleOut",
  "section": "eventSlideOut-module-scss-module__tztGla__section",
  "sectionHeading": "eventSlideOut-module-scss-module__tztGla__sectionHeading",
  "sectionHeadingHost": "eventSlideOut-module-scss-module__tztGla__sectionHeadingHost",
  "sectionHeadingSponsors": "eventSlideOut-module-scss-module__tztGla__sectionHeadingSponsors",
  "sectionSponsors": "eventSlideOut-module-scss-module__tztGla__sectionSponsors",
  "sidebar": "eventSlideOut-module-scss-module__tztGla__sidebar",
  "sidebarSectionContent": "eventSlideOut-module-scss-module__tztGla__sidebarSectionContent",
  "sidebarSectionTitle": "eventSlideOut-module-scss-module__tztGla__sidebarSectionTitle",
  "slideOutDialog": "eventSlideOut-module-scss-module__tztGla__slideOutDialog",
  "slideOutMenu": "eventSlideOut-module-scss-module__tztGla__slideOutMenu",
  "slideOutOverlay": "eventSlideOut-module-scss-module__tztGla__slideOutOverlay",
  "sponsorLink": "eventSlideOut-module-scss-module__tztGla__sponsorLink",
  "title": "eventSlideOut-module-scss-module__tztGla__title",
  "triggerButton": "eventSlideOut-module-scss-module__tztGla__triggerButton",
  "volunteersRequested": "eventSlideOut-module-scss-module__tztGla__volunteersRequested",
  "volunteersRequestedIcon": "eventSlideOut-module-scss-module__tztGla__volunteersRequestedIcon",
  "zoomIn": "eventSlideOut-module-scss-module__tztGla__zoomIn",
  "zoomOut": "eventSlideOut-module-scss-module__tztGla__zoomOut",
});
